import { createBrowserRouter, type RouteObject } from 'react-router-dom';
import BlankLayout from '../components/Layouts/BlankLayout';
import DefaultLayout from '../components/Layouts/DefaultLayout';
import { RouteErrorBoundary } from '../components/ErrorBoundary';
import { routes } from './routes';
import { meRoutes } from '../pages/Me/routes';
import { titulosRoutes } from '../pages/Titulos/routes';
import { eliteRoutes } from '../pages/Elite/routes';
import { biRoutes } from '../pages/BI/routes';
import { juridicoRoutes } from '../pages/Juridico/routes';
import { marketingRoutes } from '../pages/Marketing/routes';
import { souCapitalRoutes } from '../pages/SouCapital/routes';
import { rhRoutes } from '../pages/RH/routes';
import { gerencialRoutes } from '../pages/Gerencial/routes';
import { suprimentosRoutes } from '../pages/Suprimentos/routes';
import { visitasRoutes } from '../pages/Visitas/routes';
import { lojaRoutes } from '../pages/LojaCapital/routes';
import { posVendaRoutes } from '../pages/PosVenda/routes';

const allRoutes = [
    ...routes,
    ...meRoutes,
    ...titulosRoutes,
    ...eliteRoutes,
    ...biRoutes,
    ...juridicoRoutes,
    ...marketingRoutes,
    ...souCapitalRoutes,
    ...rhRoutes,
    ...gerencialRoutes,
    ...suprimentosRoutes,
    ...visitasRoutes,
    ...lojaRoutes,
    ...posVendaRoutes,
];

// `layout` só existe nas rotas core (auth, 404); as de módulo são RouteObject puro.
type RotaComLayout = RouteObject & { layout?: string };

// O boundary fica DENTRO do layout: página que quebra troca só o conteúdo
// pelo aviso, header/navbar continuam de pé e navegar pra outra rota recupera.
const finalRoutes = allRoutes.map((route: RotaComLayout) => {
    const page = <RouteErrorBoundary>{route.element}</RouteErrorBoundary>;

    return {
        ...route,
        element: route.layout === 'blank' ? <BlankLayout>{page}</BlankLayout> : <DefaultLayout>{page}</DefaultLayout>,
    };
});

const router = createBrowserRouter(finalRoutes);

export default router;
